import { Table } from 'react-bootstrap';
import { useGetDailyStocksQuery } from '../../slices/dailyStocksApiSlice';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useMemo } from 'react';

const DailyStockUniqueDates = () => {
  const { data, isLoading, error } = useGetDailyStocksQuery();

  const dailyStocks = useMemo(() => data?.dailyStocks || [], [data]);

  const uniqueDates = useMemo(() => {
    return dailyStocks.length > 0 
      ? [...new Set(dailyStocks.map(dailyStock => new Date(dailyStock.date).toISOString().split('T')[0]))]
      : [];
  }, [dailyStocks]);

  const sortedDates = useMemo(() => [...uniqueDates].sort((a, b) => new Date(a) - new Date(b)), [uniqueDates]);
  const date1 = sortedDates;
  
  return (
    <>
      <h1>Unique DailyStock Dates</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || 'Error fetching dailyStock dates'}</Message>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>DATE</th>
            </tr>
          </thead>
          <tbody>
            {date1.map((date, index) => (
              <tr key={index}>
                <td>{date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default DailyStockUniqueDates;